import React, { useCallback } from "react";
import { NumberedCircle } from "./NumberedCircle";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import Typography from "@material-ui/core/Typography";
import { GroopItClient } from "../../../groopit-js/client";
interface ISuggestedAssignmentNotificationContainerComponentProps {
  suggestedAssignmentIds: string[];
  returnUrl: string;
}

const numberOfNotificationsToDisplay = 3;
const GroupitClient = new GroopItClient({});

export const SuggestedAssignmentNotificationContainer = (
  props: ISuggestedAssignmentNotificationContainerComponentProps,
): JSX.Element => {
  const [startIndex, setStartIndex] = React.useState(0);

  const [showNavigateNext, setShowNavigateNext] = React.useState(true);
  const [showNavigateBefore, setShowNavigateBefore] = React.useState(true);

  const [notificationsDisplayed, setNotificationsDisplayed] = React.useState<
    string[]
  >([]);

  const getFromSuggestedAssignmentEndpointUrl = useCallback(
    (suggestedAssignmentId: string) => {
      return `/Groopit/${GroupitClient.getFromSuggestedAssignment.name}/${suggestedAssignmentId}?returnUrl=${props.returnUrl}`;
    },
    [props.returnUrl],
  );

  React.useEffect(() => {
    setNotificationsDisplayed(
      props.suggestedAssignmentIds.slice(
        startIndex,
        startIndex + numberOfNotificationsToDisplay,
      ),
    );
  }, [props.suggestedAssignmentIds, startIndex]);

  // Function that results in the hiding of the NavigateNext button if there
  // are not enough notifications to display based on the start index, the
  // number of notifications to display, and the total number of notifications.
  React.useEffect(() => {
    if (
      startIndex + numberOfNotificationsToDisplay >=
      props.suggestedAssignmentIds.length
    ) {
      setShowNavigateNext(false);
    } else {
      setShowNavigateNext(true);
    }
  }, [startIndex, props.suggestedAssignmentIds.length]);

  // Function that results in the hiding of the NavigateBefore button if there
  // are not enough notifications to display based on the start index, the
  // number of notifications to display, and the total number of notifications.
  React.useEffect(() => {
    if (startIndex === 0) {
      setShowNavigateBefore(false);
    } else {
      setShowNavigateBefore(true);
    }
  }, [startIndex]);

  const handleOnNavigateNextClicked = () => {
    if (
      startIndex + numberOfNotificationsToDisplay <
      props.suggestedAssignmentIds.length
    ) {
      setStartIndex(startIndex + numberOfNotificationsToDisplay);
    }
  };
  const handleOnNavigateBeforeClicked = () => {
    if (startIndex - numberOfNotificationsToDisplay >= 0) {
      setStartIndex(startIndex - numberOfNotificationsToDisplay);
    }
  };

  return (
    <>
      <div className="border-app-orange border-t-8 mb-8">
        <div className="border-app-gray-08 border border-b w-full p-4 flex justify-between items-center content-center">
          <div className="mr-10">
            <Typography component="span" color="secondary">
              Insights pending approval
            </Typography>
          </div>
          <div className="flex items-center justify-items-start flex-grow gap-1">
            <NavigateBeforeOutlinedIcon
              aria-label="navigate before"
              className={`text-app-orange -mx-2 ${
                showNavigateBefore ? "" : "invisible"
              }`}
              fontSize="large"
              onClick={handleOnNavigateBeforeClicked}
            />
            {notificationsDisplayed.map((id, index) => {
              return (
                <a href={getFromSuggestedAssignmentEndpointUrl(id)} key={index}>
                  <NumberedCircle
                    key={index + startIndex + 1}
                    number={index + startIndex + 1}
                    size={10}
                  />
                </a>
              );
            })}
            <NavigateNextOutlinedIcon
              aria-label="navigate next"
              className={`text-app-orange -mx-2 ${
                showNavigateNext ? "" : "invisible"
              }`}
              fontSize="large"
              onClick={handleOnNavigateNextClicked}
            />
          </div>
        </div>
      </div>
    </>
  );
};
